/** 解析 supply_post.extra_json（后台审核详情等） */

export function parseSupplyExtra(extraJson) {
  if (!extraJson) return {}
  try {
    const obj = typeof extraJson === 'string' ? JSON.parse(extraJson) : extraJson
    return obj && typeof obj === 'object' ? obj : {}
  } catch (e) {
    return {}
  }
}

export function supplyRevisionStatusCode(item) {
  const extra = parseSupplyExtra(item && item.extraJson)
  return String(extra.revisionStatus || '').trim().toUpperCase()
}

export function revisionStatusText(code) {
  const c = String(code || '').toUpperCase()
  if (c === 'PENDING') return '变更待审'
  if (c === 'REJECTED') return '变更已驳回'
  return '—'
}

export function revisionPillClass(code) {
  const c = String(code || '').toUpperCase()
  if (c === 'PENDING') return 'pill-purple'
  if (c === 'REJECTED') return 'pill-gray'
  return 'pill-gray'
}

/** 首审：仅 PENDING 可操作通过/驳回 */
export function canFirstReview(item) {
  return String(item?.reviewStatusCode || '').toUpperCase() === 'PENDING'
}

/** 变更审：已通过 + 启用 + 变更待审 */
export function canRevisionReview(item) {
  const review = String(item?.reviewStatusCode || '').toUpperCase()
  const st = String(item?.statusCode || '').toUpperCase()
  return review === 'APPROVED' && st === 'ENABLED' && supplyRevisionStatusCode(item) === 'PENDING'
}

export function supplyPendingRevision(item) {
  const extra = parseSupplyExtra(item && item.extraJson)
  if (extra.revisionStatus !== 'PENDING') return null
  return extra.pendingRevision && typeof extra.pendingRevision === 'object' ? extra.pendingRevision : null
}

export function supplyExtraDisplay(item) {
  const extra = parseSupplyExtra(item && item.extraJson)
  return {
    coopTypeText: extra.coopTypeText || '—',
    periodText: extra.periodText || '—',
    regionText: extra.regionText || '—',
  }
}

export function supplyAttachments(item) {
  const extra = parseSupplyExtra(item && item.extraJson)
  const list = Array.isArray(extra.attachments) ? extra.attachments : []
  return list.filter((x) => x && x.url && x.name)
}

export function attachmentHref(att) {
  const u = String((att && att.url) || '').trim()
  if (!u) return '#'
  if (/^https?:\/\//i.test(u)) {
    try {
      const parsed = new URL(u)
      if (parsed.pathname.startsWith('/uploads/')) return parsed.pathname
    } catch (e) {
      return u
    }
    return u
  }
  return u.startsWith('/') ? u : `/${u}`
}

function rewardLinesFromExtra(extra) {
  if (!extra || !extra.rewardOn) return null
  const type = String(extra.rewardType || 'commission').trim()
  const lines = []
  if (type === 'commission') {
    if (extra.rewardAmount) lines.push(`预估规模：${extra.rewardAmount} 元`)
    if (extra.rewardRatio) lines.push(`成交佣金比例：${extra.rewardRatio}%`)
    if (!lines.length) lines.push('佣金激励（未填具体数值）')
  } else if (extra.rewardDesc) {
    lines.push(String(extra.rewardDesc))
  } else {
    lines.push('其它激励（未填说明）')
  }
  return {
    lines,
    publicVisible: !!extra.rewardPublicVisible,
  }
}

export function supplyRewardDisplay(item) {
  const extra = parseSupplyExtra(item && item.extraJson)
  const reward = rewardLinesFromExtra(extra)
  if (!reward) return null
  return {
    ...reward,
    revisionStatus: String(extra.revisionStatus || '').trim(),
  }
}

export function supplyExtraDisplayFromExtra(extra) {
  const e = extra && typeof extra === 'object' ? extra : {}
  return {
    coopTypeText: e.coopTypeText || '—',
    periodText: e.periodText || '—',
    regionText: e.regionText || '—',
  }
}

export function supplyAttachmentsFromExtra(extra) {
  const e = extra && typeof extra === 'object' ? extra : {}
  const list = Array.isArray(e.attachments) ? e.attachments : []
  return list.filter((x) => x && x.url && x.name)
}

/** 后台「查看变更详情」：完整待审草稿展示 */
export function buildRevisionDetailView(item) {
  const pending = supplyPendingRevision(item)
  if (!pending) return null
  const extra = parseSupplyExtra(pending.extraJson)
  const reward = rewardLinesFromExtra(extra)
  return {
    postTypeCode: pending.postType || (item && item.postTypeCode) || '',
    title: pending.title || '—',
    category: pending.category || '—',
    content: pending.content || '',
    companyName: pending.companyName || '—',
    contactName: pending.contactName || '—',
    contactPhone: pending.contactPhone || '—',
    submittedAt: pending.submittedAt || '',
    extra: supplyExtraDisplayFromExtra(extra),
    attachments: supplyAttachmentsFromExtra(extra),
    reward,
  }
}